<template>
  <div>
    <list
      row-key="Junior6Id"
      ref="list"
      unit="丘成桐少年班六年级"
      :page="page"
      :query-params="params"
      :show-checkbox="true"
      :show-query="showQuery"
      :get-data-func="api.list"
      :page-sizes="[10,20,50,500,1000,2000,5000]"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="报名序号">
          <el-input v-model="params.EnrollNo" placeholder="请输入报名序号" clearable />
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="params.FullName" placeholder="请输入姓名" clearable />
        </el-form-item>
        <el-form-item label="状态" v-if="showStatus">
          <el-select v-model="params.Status" placeholder="请选择状态" clearable>
            <el-option label="待提交" :value="0"></el-option>
            <el-option label="待审核" :value="1"></el-option>
            <!-- <el-option label="审核未通过" :value="2"></el-option> -->
            <!-- <el-option label="审核通过" :value="3"></el-option> -->
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column type="index" label="序号" width="60" align="center" />
        <el-table-column prop="EnrollNo" label="报名序号" />
        <el-table-column prop="FullName" label="姓名" />
        <el-table-column prop="Sex" label="性别">
          <template slot-scope="{row}">
            <span v-if="row.Sex==1">男</span>
            <span v-else>女</span>
          </template>
        </el-table-column>
        <el-table-column prop="PrimarySchool" label="毕业学校" />
        <el-table-column prop="IdCard" label="证件号" min-width="130" />
        <el-table-column prop="Status" width="100px" label="状态" align="center">
          <template slot-scope="{row}">
            <el-tag type="info" v-if="row.Status==0">待提交</el-tag>
            <el-tag type="primary" v-else-if="row.Status==1">待审核</el-tag>
            <el-tag type="danger" v-else-if="row.Status==2">审核未通过</el-tag>
            <el-tag type="success" v-else-if="row.Status==3">审核通过</el-tag>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  props: {
    showStatus: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      api: require("@/api/po/junior6").default,
      params: {
        EnrollNo: "",
        FullName: "",
        Status: null,
        Statuses: [0,1],
      },
    };
  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>